import type { GetBrandContactsQuery } from "@src/__generated__/graphql";
import { makeObservable, observable } from "mobx";

type TBrand = NonNullable<GetBrandContactsQuery["brand"]>;

export class BrandModel {
  id: string;
  @observable name: string;
  @observable code: string;

  constructor(src: TBrand) {
    makeObservable(this);
    this.id = src.id;
    this.name = src.name;
    this.code = src.code;
  }
}
